import type React from 'react';
import { useFeatureEnabled } from '../hooks/useFeatureEnabled';

interface FeatureGateProps {
  featureKey: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  hideWhileLoading?: boolean;
}

const FeatureGate: React.FC<FeatureGateProps> = ({
  featureKey,
  children,
  fallback = null,
  hideWhileLoading = true
}) => {
  const { data, isLoading, isError } = useFeatureEnabled(featureKey);

  if (isLoading && hideWhileLoading) return <>{fallback}</>;
  if (isError) return <>{fallback}</>;
  if (data?.featureFlag?.enabled) return <>{children}</>;
  return <>{fallback}</>;
};

export default FeatureGate;
